module.exports = __webpack_public_path__ + "static/media/carbonFootprint_48.0c29ab26.png";